<template>
  <div>
    <h2>我的订单</h2>
    <a-divider></a-divider>
    <a-button type="danger" @click="toMyApply()" icon="left-circle">返回我的活动</a-button>
    <a-switch style="float:right;" checked-children="旧订单" un-checked-children="旧订单" @change="pastOrder"/>
    <br><br>
    <a-table
      class="j-table-force-nowrap"
      :scroll="{x:true}"
      ref="table"
      bordered
      size="middle"
      rowKey="id"
      :columns="columns" 
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a v-if="record.orderStatus==0" @click="toPay(record)">支付</a>
        <a v-if="record.orderStatus==1" @click="refund(record)">申请退款</a>
        <a-popconfirm v-if="record.orderStatus==-4" title="确定撤回退款申请吗?" @confirm="() => unrefund(record)">
          <a>撤回退款申请</a>
        </a-popconfirm>
        <a-divider type="vertical" />
        <a v-if="record.orderStatus==0 || record.orderStatus==-2" @click="syncCAC(record)">刷新状态</a>
      </span>
    </a-table>
    <p>如果您实际已支付但是显示为未支付，请点击刷新状态</p>
    <EventPay ref="eventPay" @payOk="search"/>
    <RefundModal ref="refundModal" @ok="search"/>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { getAction } from "@/api/manage";
import EventPay from "../modal/EventPay"
import RefundModal from "../modal/RefundModal"
export default {
  name: "Order",
  components:{
    EventPay,
    RefundModal
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      columns: [
        {
          title: "#",
          dataIndex: "",
          key: "rowIndex",
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          },
        },
        {
            title:'订单编号',
            align:"center",
            dataIndex: 'orderNo'
        },
          {
            title:'订单金额',
            align:"center",
            dataIndex: 'orderPrice',
            customRender: (value)=>{return value/100}
          },
          {
            title:'支付金额',
            align:"center",
            dataIndex: 'payPrice',
            customRender: (value)=>{return value/100}
          },
        {
          title: "状态",
          align: "center",
          width: 70,
          dataIndex: "orderStatus",
          customRender(v) {
            switch (v) {
              case 0:
                return "未支付";
              case 1:
                return "已支付";
              case -1:
                return "已全额退款";
              case -2:
                return "超时"
              case -3:
                return "确认中";
              case -4:
                return "退款申请办理中"
            }
          },
        },
        {
            title:'创建日期',
            align:"center",
            dataIndex: 'createTime'
          },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "action" },
        },
      ],
      url: {
        list: "/teaching/teachingOrder/mineEventOrder?past=false",
      },
      disableMixinCreated: true, //禁用mixin的created方法
      unitInfo: {},
    };
  },
  created() {
    this.search();
  },
  methods: {
    pastOrder(flag){
      if(flag){
        this.url.list = '/teaching/teachingOrder/mineEventOrder?past=true'
      }else{
        this.url.list = '/teaching/teachingOrder/mineEventOrder?past=false'
      }
      this.search()
    },
    search() {
      this.loading = true;
      this.loadData(1);
    },
    toMyApply(){
      this.$router.push({path: '/user/event'})
    },
    toPay(record){
        this.$refs.eventPay.open(record)
    },
    refund(r){
      this.$refs.refundModal.refund(r)
    },
    unrefund(r){
      getAction("/teaching/teachingOrder/unrefundApply",{orderNo: r.orderNo}).then(res=>{
        this.$message.info(res.message);
        this.search()
      })
    },
    //通过自动化订单
    syncCAC(record){
      getAction("/teaching/teachingOrder/checkOrderCAC?outTradeNo="+record.orderNo).then(res=>{
        this.$message.success(res.message);
        this.searchQuery()
      })
    },
  },
};
</script>

<style>
</style>